import React, { useEffect } from "react";

const GoogleAnalytics = () => {
  /**
   * Initialize Google Tag Manager tracking code for production (livis.ai)
   */
  useEffect(() => {
    if (window.location.href.startsWith("https://livis.ai/")) {
      // Inject the GTM script dynamically
      const script1 = document.createElement("script");
      script1.async = true;
      script1.src = "https://www.googletagmanager.com/gtag/js?id=G-9LGH42R9WV";

      const script2 = document.createElement("script");
      script2.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag() { dataLayer.push(arguments); }
                gtag('js', new Date());
                gtag('config', 'G-9LGH42R9WV');
            `;

      document.head.appendChild(script1);
      document.head.appendChild(script2);

      const clarityScript = document.createElement("script");
      clarityScript.type = "text/javascript";
      clarityScript.innerHTML = `
                (function(c,l,a,r,i,t,y){
                    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
                })(window, document, "clarity", "script", "u0tpz1tlan");
            `;
      document.head.appendChild(clarityScript);

      console.log("GTM script loaded for livis.ai in production");
    } else {
      console.log("GTM script not loaded (not in production or wrong URL)");
    }
  }, []);

  return null; // No UI elements needed
};

export default GoogleAnalytics;
